<template>
  <div class="postDetailApp" :style="'min-height:'+curHeight+'px'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    

    <div class="card" v-if="active == 0">
      <ul>
        <li v-for="(item,i) in arr" @click="toPush(item.id,'prodetail')">
          <h3>{{item.title}}</h3>
          <div class="price"><font>售<i style="opacity:0">场</i>价：</font>￥{{item.rate}}</div>
          <div class="rate"><font>市场价：</font><span style="text-decoration: line-through">￥{{item.price}}</span></div>
          <a>购买</a>
        </li>
        
      </ul>
    </div>

  </div>
</template>

<script>
  export default {
    data() {
      return {
        userData:[],
        curHeight:0,
        fullscreenLoading: true,
        baseUrl:'',
        setDetail:[],
        active:0,
        arr:[],
        positionFlag:false
      };
    },
    created(){
      this.userData = localStorage.getItem('userjwt') == null ? [] : JSON.parse(localStorage.getItem('userjwt'));
    },
    beforeMount() {
      this.baseUrl = this.$host;
    },
    mounted() {
      this.beforeMount();
      this.getDetail()
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
      toPush:function(index,url){
        this.$router.push({
          path:url,
          query:{
            id:index
          }
        })
      },
      toggle(index){
        this.active=index;
      },
      getDetail:function(e){
        var that = this;
        var id = this.$route.query.id;
        this.axios({
          method:'post',
          url:that.$host+'home/index/detail',
          params:{
            id:id
          }
        }).then(function(response){
          var res = response.data;
          that.setDetail = res.data.rs;
          that.arr = res.data.arr;
          that.fullscreenLoading = false;
        }).catch(err=>{
          console.log('请求失败:'+err);
        });
      },
    },
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .postDetailApp{
    background:#f5f5f5;
  }

  .postDetailApp .card{
    width:100%;
    display:block;
    padding-top:10px;
    min-height:400px
  }
  .postDetailApp .card ul{
    width:94%;
    display:block;
    margin:0 auto;

  }
  .postDetailApp .card ul li{
    background:#fff;
    width:100%;
    margin-bottom:8px;
    border-radius:8px;
    position:relative;
  }
  .postDetailApp .card ul li h3{
    font-size:16px;
    padding:15px 15px 10px 15px;
    width:75%;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    letter-spacing:1px
  }

  .postDetailApp .card ul li .price{
    font-size:15px;
    padding:0 15px 10px 15px;
    color:#007aff
  }
  .postDetailApp .card ul li .rate{
    font-size:15px;
    padding:0 15px 10px 15px;
    color:#333
  }
  .postDetailApp .card ul li .price font{
    color:#333;
    font-size:15px
  }
  .postDetailApp .card ul li a{
    position:absolute;
    right:20px;
    top:60%;
    transform: translateY(-50%);
    background:green;
    padding:6px 15px;
    color:#fff;
    border-radius:5px;
  }

  
</style>